import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { legalContent, legalDisclaimer } from "@/content/legal";
import { useLanguage } from "@/context/LanguageContext";

export default function Legal({ type }) {
  const { t } = useLanguage();
  const content = legalContent[type];

  return (
    <div className="bg-slate-50 text-slate-900 antialiased min-h-screen" data-testid={`legal-${type}`}>
      <Header />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <p className="text-[11px] font-mono-spec text-slate-400 mb-6">{t.legal.note}</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-950 mb-10" data-testid="legal-title">
          {content.title}
        </h1>

        <div className="space-y-8">
          {content.sections.map((s) => (
            <section key={s.heading} id={s.id} className="bg-white border spec-border p-6 rounded-sm scroll-mt-24">
              <h2 className="text-base font-bold text-slate-950 mb-3">{s.heading}</h2>
              {s.paragraphs.map((p, i) => (
                <p key={i} className="text-sm text-slate-600 leading-relaxed whitespace-pre-line mb-3 last:mb-0">
                  {p}
                </p>
              ))}
            </section>
          ))}
        </div>

        <p className="mt-10 text-[11px] font-mono-spec text-slate-400 border-t spec-border pt-4" data-testid="legal-disclaimer">
          {legalDisclaimer}
        </p>
      </div>
      <Footer />
    </div>
  );
}
